import React from 'react'
import { roleHooks } from '.'
import { Button } from '@mui/material'
import { Close } from '@mui/icons-material'
import { RemoveRoleBtnStyles } from './Style'

const RemoveDefaultRoleBtn = () => {
    const removeDefaultRole = roleHooks.useRemoveDefaultRole()

    return (
        <RemoveRoleBtnStyles>
            <div className='default-role'>
                <Button onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    removeDefaultRole()
                }}>
                    <Close />
                    {"מוגדר כברירת מחדל"}
                </Button>
            </div>
        </RemoveRoleBtnStyles>
    )
}

export default RemoveDefaultRoleBtn